import * as Yup from 'yup';

export enum ConfigurationFields {
  Tasks = 'tasks',
  DefaultTasks = 'defaultTasks',
  TeamMembers = 'teamMembers',
  DefaultTeamMembers = 'defaultTeamMembers',
  Comments = 'comments'
}

export const CONFIGURATION_TITLES = {
  [ConfigurationFields.DefaultTasks]: 'Task',
  [ConfigurationFields.DefaultTeamMembers]: 'Team Member',
  [ConfigurationFields.Comments]: 'Comments'
};

export const CONFIGURATION_PLACEHOLDERS = {
  [ConfigurationFields.DefaultTasks]: 'Choose at least one task',
  [ConfigurationFields.DefaultTeamMembers]: 'Choose at least one team member',
  [ConfigurationFields.Comments]: 'You can add comments to the team members to whom you assign the assignment'
};

export const VALIDATION_SCHEMA = Yup.object().shape({
  [ConfigurationFields.DefaultTasks]: Yup.array().required('This field is required.'),
  [ConfigurationFields.DefaultTeamMembers]: Yup.array().required('This field is required.')
});
